<ng-container *ngFor="let item1 of targetItems | keyvalue; trackBy: trackDetailItem">
  <mat-card class="connectivity-status-card" *ngIf="!isLoading">
    <mat-card-content class="status-card-content">
      <ng-container [ngSwitch]="true">
        <ng-container *ngSwitchCase="isObject(item1.value)">
          <ul>
            <ng-container *ngFor="let item of item1.value | keyvalue : originalOrder">
              <ng-container [ngSwitch]="true">
                <ng-container *ngSwitchCase="isObject(item.value)">
                  <ul>
                    <div *ngFor="let subItem of item.value | keyvalue : originalOrder">
                      <div matLine class="fs-text-secondary">{{ toStartCase(subItem.key) }}:</div>
                      <div matLine>
                        {{ subItem.value }}
                      </div>
                    </div>
                  </ul>
                </ng-container>
                <ng-container *ngSwitchCase="isArrays(item.value)">
                  <ng-container *ngIf="item?.value?.length">
                    <div matLine class="fs-text-secondary">{{ toStartCase(item.key) }}:</div>
                    <ul>
                      <div *ngFor="let subItem of item.value | keyvalue : originalOrder">
                        <div
                          *ngFor="let subItem2 of subItem.value | keyvalue : originalOrder"
                        ></div>
                      </div>
                    </ul>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div>
                    <div matLine>{{ item.value }}</div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ul>
        </ng-container>
        <ng-container *ngSwitchCase="isArrays(item1.value)">
          <ng-container *ngIf="item1.value?.length">
            <mat-list style="width: 100%">
              <ng-container *ngIf="item1.key === 'switchMeta'; else recursiveTmpl">
                <ng-container *ngFor="let item of formatDataKeys(item1.value)">
                  <div matLine class="fs-text-secondary">{{ toStartCase(item.key) }}:</div>
                  <div matLine>{{ item.value }}</div>
                </ng-container>
              </ng-container>
              <ng-template #recursiveTmpl>
                <div *ngFor="let item of item1.value | keyvalue : originalOrder">
                  <ng-container [ngSwitch]="true">
                    <ng-container *ngSwitchCase="isObject(item.value)">
                      <ng-container *ngFor="let subItem of item.value | keyvalue">
                        <div class="excludedData-list" *ngIf="!excludeData(subItem.key)">
                          <div mat-line class="sub-key">{{ toStartCase(subItem.key) }}:</div>
                          <div mat-line>{{ subItem.value }}</div>
                        </div>

                        <span *ngFor="let modemMeta of subItem.value | keyvalue">
                          <mat-divider></mat-divider>
                          <h4
                            class="key-titles"
                            *ngIf="subItem.key !== 'geoStatus' && subItem.key !== 'portStatus'"
                          >
                            {{ toStartCase(subItem.key) }}
                          </h4>
                          <mat-divider></mat-divider>

                          <div *ngIf="excludeData(subItem.key)">
                            <div>
                              <ng-container
                                *ngFor="let item of modemMeta.value | keyvalue : originalOrder"
                              >
                                <ng-container [ngSwitch]="true">
                                  <ng-container *ngSwitchCase="isObject(item.value)">
                                    <div class="sub-list">
                                      <div
                                        *ngFor="
                                          let subItem of item.value | keyvalue : originalOrder
                                        "
                                      >
                                        <div matLine class="sub-key">{{ subItem.key }}:</div>
                                        <div matLine>{{ subItem.value }}</div>
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngSwitchDefault>
                                    <div class="default-list">
                                      <div mat-line class="sub-key">
                                        {{ toStartCase(item.key) }}:
                                      </div>
                                      <div mat-line>{{ item.value }}</div>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </span>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="isArrays(item.value)">
                      <ng-container *ngIf="item?.value?.length">
                        <ul>
                          <div *ngFor="let subItem of item.value | keyvalue : originalOrder">
                            <div *ngFor="let subItem2 of subItem.value | keyvalue : originalOrder">
                              <div matLine>{{ subItem2.value }}</div>
                            </div>
                          </div>
                        </ul>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <mat-card-title>{{ toStartCase(item.value) }}</mat-card-title>
                      <mat-divider></mat-divider>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-template>
            </mat-list>
          </ng-container>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>
</ng-container>
